"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactWindow = require("react-window");
var _UseFocus = _interopRequireDefault(require("./UseFocus"));
var _Option = _interopRequireDefault(require("./Option"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var OptionList = function OptionList(props) {
  var commonProps = props.commonProps,
    componentProps = props.componentProps;
  var maxDropdownHeight = componentProps.maxDropdownHeight,
    onOptionChange = componentProps.onOptionChange,
    handleSelectGroup = componentProps.handleSelectGroup,
    checkGroupSelectionStatus = componentProps.checkGroupSelectionStatus,
    isGroup = componentProps.isGroup,
    isChildOption = componentProps.isChildOption;
  var automationid = commonProps.automationid,
    dataMetrics = commonProps.dataMetrics,
    options = commonProps.options,
    value = commonProps.value,
    searchInputValue = commonProps.searchInputValue;
  var menuListRef = (0, _react.useRef)();
  var ref = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    boundedHeightOffset = _useState2[0],
    setBoundedHeightOffset = _useState2[1];
  var itemHeight = 35;
  var _useFocus = (0, _UseFocus["default"])(options.length, onOptionChange),
    _useFocus2 = (0, _slicedToArray2["default"])(_useFocus, 2),
    focus = _useFocus2[0],
    setFocus = _useFocus2[1];
  (0, _react.useEffect)(function () {
    var elem = menuListRef.current;
    if (elem) {
      var bounding = elem.getBoundingClientRect();

      // Check if it's out of the viewport on each side
      var outOfBounds = bounding.bottom > window.innerHeight;
      if (outOfBounds === true && maxDropdownHeight - boundedHeightOffset >= itemHeight) {
        setBoundedHeightOffset(boundedHeightOffset + itemHeight);
      }
    }
  }, [boundedHeightOffset, itemHeight, maxDropdownHeight]);
  var optionsWithGroupLabels = (0, _react.useMemo)(function () {
    return options.map(function (option) {
      return option.groupLabel ? {
        groupLabel: true,
        label: option.groupLabel,
        value: option === null || option === void 0 ? void 0 : option.value
      } : option;
    });
  }, [options]);
  var valueMap = value.reduce(function (acc, valueObj) {
    return _objectSpread({}, acc, (0, _defineProperty2["default"])({}, valueObj.value, valueObj));
  }, {});
  var optCount = optionsWithGroupLabels.length;
  var totalItemHeight = itemHeight * Math.max(optCount, 1);
  var calculatedMaxHeight = Math.max(itemHeight, maxDropdownHeight - boundedHeightOffset);
  var height = Math.min(calculatedMaxHeight, totalItemHeight);
  var Row = (0, _react.useCallback)(function (_ref) {
    var index = _ref.index,
      style = _ref.style;
    var option = optionsWithGroupLabels[index];
    var isSelected = false;
    var isIndeterminate = false;
    if (isGroup(option)) {
      var _checkGroupSelectionS = checkGroupSelectionStatus(optionsWithGroupLabels, value, option),
        isAllSelected = _checkGroupSelectionS.isAllSelected,
        indeterminate = _checkGroupSelectionS.indeterminate;
      isSelected = isAllSelected;
      isIndeterminate = indeterminate;
    } else {
      isSelected = valueMap[option.value] !== undefined;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: style
    }, /*#__PURE__*/_react["default"].createElement(_Option["default"], {
      focus: focus === index,
      groupLabel: (option === null || option === void 0 ? void 0 : option.groupLabel) === true || false,
      key: option.value,
      index: index,
      ref: ref,
      setFocus: setFocus,
      searchInputValue: searchInputValue,
      onChange: option.options ? handleSelectGroup : onOptionChange,
      isSelected: !isIndeterminate && isSelected,
      value: option.value,
      label: option.label,
      isDisabled: option.isDisabled,
      isGroup: isGroup(option),
      isChildOption: isChildOption(option),
      indeterminate: isIndeterminate
    }));
  }, [checkGroupSelectionStatus, focus, handleSelectGroup, isChildOption, isGroup, onOptionChange, optionsWithGroupLabels, searchInputValue, setFocus, value, valueMap]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: menuListRef,
    automationid: "".concat(automationid, "-option-list"),
    "data-metrics": dataMetrics.optionList
  }, /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    height: height,
    itemCount: optCount,
    itemSize: itemHeight
  }, Row));
};
OptionList.propTypes = process.env.NODE_ENV !== "production" ? {
  commonProps: _propTypes["default"].object,
  componentProps: _propTypes["default"].object
} : {};
var _default = OptionList;
exports["default"] = _default;